export default {
  state: {
    list: [],
  },
  mutations: {
    setCountries(state, payload) {
      state.list = payload
    },
  },
  actions: {
    queryCountries({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'countries')
        .then(res => {
          commit('setCountries', res.data)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeCountry({dispatch, commit}, formData) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'countries', formData)
        .then(res => {
          dispatch('queryCountries')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateCountry({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'countries/' + payload[0], payload[1])
        .then(res => {
          dispatch('queryCountries')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyCountry({dispatch, commit}, country_id) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'countries/' + country_id)
        .then(res => {
          dispatch('queryCountries')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getCountries: state => {
      return state.list
    },
    getCountriesNames: state => {
      let countries = []
      if (state.list)
        for (let item of state.list)
          countries.push(item.name)
      countries.unshift('All')
      return countries
    },
    getCountriesName(state) {
      return function (id) {
        if (Array.isArray(id)) {
          id = id.map(str => str * 1)
          let array = []
          for (let item of state.list)
            if (id.includes(item.id))
              array.push(item.name)
          return array
        } else {
          for (let item of state.list)
            if (item.id == id)
              return item.name
        }
      }
    },
    getCountriesOptions(state) {
      return function (all) {
        let countries = []
        if (state.list)
          for (let item of state.list)
            countries.push({id: item.id, text: item.name})
        if (all)
          countries.unshift({id: 0, text: 'All'})
        return countries
      }
    }
  }
}